import Nav from "./nav"
import Search from "./search"
import Slider from "./slider"
import ValuesDropdown from "./values-dropdown"
import Suggestion from "./suggestion"
import FeatureDropdown from "./feature-dropdown"
import Features from "./features"
import Filters from "./filters"
import RepeatedSentence from "./repeated-sentence"
import TitleAnimation from "./title-animation"
import IntroAnimation from "./intro-animation"
import PrimaryCardAnimation from "./primary-card-animation"
import ShowPassword from "./show-password"
import Dialog from "./dialog"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Slider(jQuery)
    ValuesDropdown(jQuery)
    Suggestion(jQuery)
    FeatureDropdown(jQuery)
    Features(jQuery)
    Filters(jQuery)
    RepeatedSentence(jQuery)
    TitleAnimation(jQuery)
    IntroAnimation(jQuery)
    PrimaryCardAnimation(jQuery)
    ShowPassword(jQuery)
    Dialog(jQuery)
})
